import * as React from 'react';
import { StandardLocalWidget, any, fromJSX } from "widgets-for-react";
import { SubscriptionLayout } from '../../subscription/subscriptionLayout';
import { DataLayer, PIIData } from '../../utils/datalayer';
import { AllPaymentTypes, IDealIssuer, PaymentMethodState, paymentMethodStateUpdaters, paymentMethodUpdaters, paymentTypeLabel } from "./paymentMethodState";


export const paymentMethodWidget = (iDealIssuers: Array<IDealIssuer>, piiData?: PIIData): StandardLocalWidget<PaymentMethodState> => currentState =>
  any([
    currentState.validator.widget().map(paymentMethodStateUpdaters.validation),
    fromJSX(setState =>
      <SubscriptionLayout.PaymentMethodChoice
        paymentMethods={AllPaymentTypes}
        iDealIssuers={iDealIssuers}
        currentBank={currentState.input.paymentType}
        currentIdealIssuer={currentState.input.iDealIssuer?.Title || ""}
        select={(newValue => {
          setState(paymentMethodStateUpdaters.input(paymentMethodUpdaters.paymentType(_ => AllPaymentTypes.find(pt => paymentTypeLabel(pt) == paymentTypeLabel(newValue)))))
          DataLayer.upgradeFlowStep3("paymentMethod", piiData, AllPaymentTypes.find(pt => paymentTypeLabel(pt) == paymentTypeLabel(newValue)))
        }
        )}
        selectIdealIssuer={(newValue =>
          setState(paymentMethodStateUpdaters.input(paymentMethodUpdaters.iDealIssuer(_ =>
            iDealIssuers.find(i => i.Title == newValue.Title) || _
          )))
        )}
        IdealIssuerValidation={currentState.validatorResult.path("iDealIssuer", "name")}
      />
    )
  ])
